import React from "react";

import Loader from "../common/Loader";
import { useSelector,shallowEqual } from "react-redux";

const GlobalLoader = () => {
  const { isLoading, title, content,loader } = useSelector(state => state.loaderReducer.app,shallowEqual);

  return <Loader isLoading={isLoading} title={title} content={content} loader={loader} global/>;
};

export default GlobalLoader;
